import { maybe } from '@passionware/monads';
import { MetastructureField } from '__types__';
import type { ResourceTypeWorkspaceBinding } from 'v5/api/resource-types/resource-type-bindings.api';
import { appScopeUtils } from 'v5/core/app-scope/appScope.types';
import {
  mergeWorkspaceMetastructureFields,
  type MergedWorkspaceMetastructure
} from 'v5/services/internal/ResourceTypeBindingsService/mergeWorkspaceMetastructureFields';
import type { MetastructureRequest } from './MetastructureMappingService';

/**
 * One merge for catalog + write lens.
 * `undefined` when merge does not run (org / non-resource).
 */
export function mergedWorkspaceMetastructureForRequest(
  fields: MetastructureField[],
  request: MetastructureRequest,
  bindings: ResourceTypeWorkspaceBinding[]
): MergedWorkspaceMetastructure | undefined {
  if (request.type !== 'resource') {
    return undefined;
  }
  return maybe.mapOrElse(
    appScopeUtils.getWorkspaceId(request.scope),
    workspaceId =>
      mergeWorkspaceMetastructureFields(
        fields,
        bindings,
        request.subtypeId,
        workspaceId
      ),
    undefined
  );
}

export function withWorkspaceOverlay(
  fields: MetastructureField[],
  request: MetastructureRequest,
  bindings: ResourceTypeWorkspaceBinding[]
): MetastructureField[] {
  const merged = mergedWorkspaceMetastructureForRequest(
    fields,
    request,
    bindings
  );
  return merged ? merged.fields.filter(field => field.active) : fields;
}
